let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("2za3m")).then(() => parcelRequire('71tek'));